export function canViewRequestProfileProviders(requestPermissions) {
  return (
    requestPermissions?.can_view_contractors ||
    requestPermissions?.can_view_recommended_contractors ||
    requestPermissions?.can_view_workers
  )
}
